import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './components/pages/anwendung/main/main.component';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { GlobalConstantsRouting } from 'globales-projekt-angular';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { ConstantsRouting } from './immutable/constants-routing';
import { DefinitionUndAnwendungsbereichComponent } from './components/pages/navbar-pages/definition-und-anwendungsbereich/definition-und-anwendungsbereich.component';
import { AbkuerzungsverzeichnisComponent } from './components/pages/navbar-pages/abkuerzungsverzeichnis/abkuerzungsverzeichnis.component';
import { LiteraturComponent } from './components/pages/navbar-pages/literatur/literatur.component';
import { PseudonymisierungCodeComponent } from './components/pages/navbar-pages/pseudonymisierungCode/pseudonymisierungCode.component';
import { PseudonymisierungVerfahrenComponent } from './components/pages/navbar-pages/pseudonymisierungVerfahren/pseudonymisierungVerfahren.component';

const routes: Routes = [
  { path: '', redirectTo: GlobalConstantsRouting.MAIN, pathMatch: GlobalConstantsRouting.PATH_MATCH },
  { path: GlobalConstantsRouting.MAIN, component: MainComponent },
  { path: GlobalConstantsRouting.ERGEBNISSE, component: ErgebnisseComponent },
  { path: GlobalConstantsRouting.HILFE, component: HilfeComponent },
  { path: GlobalConstantsRouting.ABKUERZUNGSVERZEICHNIS, component: AbkuerzungsverzeichnisComponent },
  { path: GlobalConstantsRouting.LITERATUR, component: LiteraturComponent }, 
  { path: ConstantsRouting.DEFINITION_UND_ANWENDUNGSBEREICH, component: DefinitionUndAnwendungsbereichComponent },  
  { path: ConstantsRouting.PSEUDONYMISIERUNG_VERFAHREN, component: PseudonymisierungVerfahrenComponent },
  { path: ConstantsRouting.PSEUDONYMISIERUNG_CODE, component: PseudonymisierungCodeComponent },
  { path: GlobalConstantsRouting.PAGE_NOT_FOUND, component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
